import { primary } from "@/styles/variable"
import styled from "styled-components"

interface ISessionTagContainerProps {
  color?: string
  radius?: string
}

export const SessionTagContainer = styled.button<ISessionTagContainerProps>`
  display: inline-flex;
  flex-wrap: wrap;
  padding: 5px 10px;
  align-items: flex-start;
  gap: 20px;
  border: none;
  outline: none;
  cursor: pointer;
  border-radius: ${props => props.radius};
  background-color: ${props => props.color};
  &.active {
    background: ${primary.black};
    span {
      color: ${primary.white}!important;
    }
  }
`

export const SessionTagTitle = styled.span`
  color: ${primary.black};
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`
